module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_5012.a435d61b.png";